const profession = [
  "Instalador Hidráulico",
  "Marido de aluguel",
  "Mestre de obras",
  "Encanador",
  "Assentador",
  "Azulegista",
  "Eletricista",
  "Pedreiro",
  "Engenheiro",
  "Outros",
];

export default profession;
